import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Scrolla para o topo da página a cada mudança de rota,
 * evitando que o usuário chegue no meio ou no footer da página destino.
 */
const ScrollToTop: React.FC = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  }, [pathname]);

  return null;
};

export default ScrollToTop;
